import { REMOVE_MEMBER_BENEFIT } from '../constants/ActionTypes';

export default function removeMemberBenefit(passNumberToRemove) {
  return dispatch => {
    dispatch({
      type: REMOVE_MEMBER_BENEFIT,
      passNumberToRemove
    });
  };
}
